import { ResponseError } from '../connectors/backend';

export interface ApiErrorDetail {
  code?: string;
  message?: string | null;
  status?: number;
  /** Extra context the backend attaches to some codes, e.g. the missing input names. */
  details?: string[] | null;
  /** A validation problem's messages by input path, e.g. `settings.orders.phases[0].code`. */
  errors?: Record<string, string[]> | null;
}

/**
 * A response body can be read once, but a query keeps its error in the cache and
 * hands it back on every render, so the parse is remembered per error object.
 */
const parsedDetails = new WeakMap<
  ResponseError,
  Promise<ApiErrorDetail | null>
>();

export function parseApiErrorDetail(
  error: unknown,
): Promise<ApiErrorDetail | null> {
  if (!(error instanceof ResponseError)) {
    return Promise.resolve(null);
  }

  let detail = parsedDetails.get(error);
  if (!detail) {
    detail = error.response
      .json()
      .then((body) => body as ApiErrorDetail)
      .catch(() => null);
    parsedDetails.set(error, detail);
  }

  return detail;
}
